import { ApiService } from "../apiService";

export class AuthService extends ApiService {
    constructor() {
        super();
        
        this.path = '/Auth';
    }

    /**
     * Execute login 
     * @param {*} username 
     * @param {*} password 
     */
    login(username, password) {
        return this.get(this.path, {
            params: {
                username: username,
                password: password,
            }
        });
    }
}